import { graphql } from 'gatsby';
import { getKey } from '../../../helpers';

/**
 * TitleDescription definition
 * @param {Object} props of the widget
 * @param {string} locale of the widget
 * @returns {Object} widget definition
 */
export default function titleDescription(props, locale) {
  return {
    type: 'ticketdescription',
    key: getKey(props, 'key'),
    title: getKey(props, `title_${locale}`),
    description: getKey(props, `description_${locale}`),
  };
}

/**
 * GraphQL query
 */
export const query = graphql`
  fragment TitleDescription on StrapiWidgetrels {
    titledescription {
      key: id
      title_en
      title_es
      description_en
      description_es
      widgetPosition
    }
  }
`;
